import {base} from '@/services/api'
import {request, METHOD, removeAuthorization} from '@/utils/request'

/**
 * 登录服务
 * @param username 账户名
 * @param password 账户密码
 * @returns {Promise<AxiosResponse<T>>}
 */
// qf35
export async function login(username, password,code,uuid) {
  return request(base.LOGIN, METHOD.POST, {
    password:password,
    userNo:username,
    type:0,
    captcha:code,
    uuid:uuid
  })
}

export async function getUserInfo() {
  return request(base.USER, METHOD.GET)
}

export async function getPermissions() {
  return request(base.PERMISSIONS, METHOD.GET)
}

export async function getRoutesConfig() {
  return request(base.ROUTES, METHOD.GET)
}

/**
 * 退出登录
 */
export function logout() {
  localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY)
  localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY)
  localStorage.removeItem(process.env.VUE_APP_ROLES_KEY)
  removeAuthorization()
}

export default {
  login,
  logout,
  getUserInfo,
  getPermissions,
  getRoutesConfig
}
